import React from 'react';

import { capitalize } from 'lodash';

import LoadingSpinner from 'components/ui/loading_spinner';

interface Props {
  status: string;
}

export default function DromoImportStatus({ status }: Props) {
  let className;
  let content = <span>{capitalize(status.replace(/_/g, ' '))}</span>;

  if (status === 'failed' || status === 'reverting' || status === 'reverted' || status === 'revert_failed') {
    className = 'text-danger';
  } else if (status === 'pending') {
    className = 'text-muted';
  } else if (status === 'processing') {
    content = <>
      {content}
      <LoadingSpinner className="ms-2" inline size="md" />
    </>;
  }

  return <span className={className}>{content}</span>;
}
